module.exports = __webpack_public_path__ + "svg/fit-guarantee.a13672f0a7ee5f67646344a19c063f55.svg";